import { LbTilingApiClient, RestApiConfig } from '@onaptek/lbtiling.restapi-access-sdk';
import { getAdminToken } from '../utils/auth';

// API base URL configuration
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3002';

/**
 * Create and configure the LB Tiling API client
 */
function createApiClient(): LbTilingApiClient {
  const token = getAdminToken();
  
  const config: RestApiConfig = {
    baseUrl: API_BASE_URL,
    timeout: 30000,
    headers: {
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache, no-store, must-revalidate',
      'Pragma': 'no-cache',
      'Expires': '0',
      ...(token && { Authorization: `Bearer ${token}` }),
    },
  };

  return new LbTilingApiClient(config);
}

// Export a singleton instance of the API client
export const apiClient = createApiClient();

// Export function to recreate client with fresh token
export const refreshApiClient = () => {
  const newClient = createApiClient();
  // Update the exported client properties
  Object.assign(apiClient, newClient);
  return apiClient;
};

export default apiClient;